var _clipPath, _linearGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1086.12 1176.43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(31.63 -53.32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m728 391.75-39.18-80.45a44.81 44.81 0 0 0 -19.67-20.18 39.38 39.38 0 0 0 -19.55-5.19h-19.39a130.66 130.66 0 0 1 -245.11 0h-19.39a39.49 39.49 0 0 0 -30.71 14.6 45.18 45.18 0 0 0 -7.36 10.77l-39.17 80.45a45.12 45.12 0 1 0 81.13 39.51l8.05-16.52h261.17l8 16.52a45.12 45.12 0 0 0 81.18-39.51zm-219.76-61.16a88.3 88.3 0 1 0 -88.24-88.3 88.29 88.29 0 0 0 88.29 88.3m14.9 486.22a45.12 45.12 0 0 1 47.78-42.3l18.34 1.12 128.33-227.42-10.44-15.13a45.12 45.12 0 0 1 74.29-51.23l50.8 73.66a45.07 45.07 0 0 1 5.77 11.71 39.51 39.51 0 0 1 -2.38 33.9l-9.53 16.88a130.66 130.66 0 0 0 -120.49 213.45l-9.53 16.89a39.42 39.42 0 0 1 -14.13 14.47 44.85 44.85 0 0 1 -27.25 7.19l-89.31-5.43a45.12 45.12 0 0 1 -42.3-47.76zm203.54-113.52a88.29 88.29 0 1 0 120.27-33.49 88.29 88.29 0 0 0 -120.29 33.49m-489-219.61-49.59 74.48a44.82 44.82 0 0 0 -7.46 27.18 39.33 39.33 0 0 0 5.34 19.49l9.8 16.73a130.66 130.66 0 0 1 124 211.44l9.81 16.73a39.5 39.5 0 0 0 28.11 19.09 45.37 45.37 0 0 0 13 .9l89.28-6.88a45.12 45.12 0 1 0 -6.94-90l-18.33 1.41-132.12-225.25 10.19-15.3a45.12 45.12 0 0 0 -75.12-50zm58.37 220.51a88.29 88.29 0 1 0 -31.55 120.81 88.29 88.29 0 0 0 31.52-120.82"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(1.2 0 0 1.03 403.97 145.93)",
    gradientUnits: "userSpaceOnUse",
    x1: -336.42,
    x2: 514.81,
    y1: 479.83,
    y2: 479.83
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc8621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fc811f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fd7419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fe5e0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#ff3f01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff3c00"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.37 185.31h1025.6v912.45h-1025.6z",
    fill: "url(#b)",
    transform: "matrix(.18463752 .98280669 -.98280669 .18463752 1079.14 -32.86)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.8c21d4946702ad0af88ec25172278fad.svg";